<script lang="ts">import { Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
export let image = "";
export let title = null;
export let info = null;
export let width = "";
export let variant = "default";
</script>

{#if title && info}
	<InfoCard {width} fullWidthMobile>
		<div class="content-info-card" class:horizontal={variant === 'horizontal'}>
			<div class="text-container" class:text-container-horizontal={variant === 'horizontal'}>
				<Text
					type="title"
					titleSize="h5"
					textColor="white"
					customStyle="position:relative; z-index:10;">{title}</Text
				>
				<Text
					type="body"
					bodySize="medium"
					textAlign={variant !== 'horizontal' ? 'center' : 'start'}
					customStyle="position:relative; z-index:10;">{info}</Text
				>
			</div>
			<img
				src={image}
				alt={title}
				class="image"
				class:image-horizontal={variant === 'horizontal'}
			/>
			<img
				src={image}
				alt={title}
				class="image-background"
				class:image-background-horizontal={variant === 'horizontal'}
			/>
		</div>
		<div class="content-info-card content-info-card-mobile">
			<Text
				type="title"
				titleSize="h5"
				textColor="white"
				customStyle="position:relative; z-index:10;">{title}</Text
			>
			<Text
				type="body"
				bodySize="medium"
				textAlign="center"
				customStyle="line-height: 168%; position:relative; z-index:10;">{info}</Text
			>
			<img src={image} alt={title} class="image" />
			<img src={image} alt={title} class="image-background image-background-mobile" />
		</div>
	</InfoCard>
{/if}

<style>
	.text-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.5rem
}

	.text-container-horizontal {
		display: flex;
		max-width: 50%;
		flex-direction: column;
		align-items: flex-start;
		gap: 0.5rem;
		text-align: start
}

	.image {
		z-index: 10;
		margin-bottom: 0.5rem;
		height: 100%;
		width: auto;
		-o-object-fit: cover;
		   object-fit: cover
}

	.image-horizontal {
		padding-right: 6rem
}

	.image-background {
		position: absolute;
		top: -2.25rem;
		right: -2.25rem;
		height: 105%;
		width: auto;
		opacity: 0.2;
		--tw-blur: blur(2px);
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
		transform: scaleX(-1)
}

	.image-background-mobile {
		left: 150px;
		top: 25%;
		height: 80%;
		opacity: 0.1
}

	.image-background-horizontal {
		--tw-rotate: 45deg;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

	.content-info-card {
		position: relative;
		z-index: 10;
		display: none;
		height: 100%;
		flex-direction: column;
		align-items: center;
		gap: 0.5rem;
		padding: 0.5rem
}
	@media (min-width: 1024px) {
		.content-info-card {
				display: flex
		}
	}
	@media (min-width: 1280px) {
		.content-info-card {
				padding: 1rem
		}
	}

	.content-info-card-mobile {
		display: flex;
		gap: 1rem;
		padding: 1rem
}
	@media (min-width: 1024px) {
		.content-info-card-mobile {
				display: none
		}
	}

	.horizontal {
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		gap: 0.5rem
}
</style>
